interface Iprops {
  width: number;
  height: number;
  
}

export const CheckIcon = ({ width, height }: Iprops) => {
  return (
    <svg
      style={{ marginRight: "0px" }}
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M13.3334 4L6.00002 11.3333L2.66669 8"
        stroke="#FCFDFD"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

